/* Libellés éditables des interactions V9. Aucun appel réseau ou formulaire. */
(() => {
  const initialized = new WeakSet();
  function bind(scope) {
    scope.querySelectorAll('.menu-button, [data-ritual-motion], #gallery-status').forEach(node => {
      if (initialized.has(node)) return;
      initialized.add(node);
      const sync = () => {
        if (node.matches('.menu-button')) {
          const label = node.getAttribute('aria-expanded') === 'true' ? node.dataset.closeLabel : node.dataset.openLabel;
          if (node.getAttribute('aria-label') !== label) node.setAttribute('aria-label', label);
        } else if (node.matches('[data-ritual-motion]')) {
          const label = node.getAttribute('aria-pressed') === 'true' ? node.dataset.pausedText : node.dataset.playingText;
          if (node.textContent !== label) node.textContent = label;
        } else {
          const labels = {
            'Cette photo ne charge pas. Vous pouvez explorer les autres vues.': node.dataset.errorText,
            'Cette vue est indisponible. La photo du produit est affichée.': node.dataset.fallbackText
          };
          const label = labels[node.textContent];
          if (label && node.textContent !== label) node.textContent = label;
        }
      };
      new MutationObserver(sync).observe(node, { attributes: true, attributeFilter: ['aria-expanded', 'aria-pressed', 'aria-label'], childList: true, characterData: true, subtree: true });
      sync();
    });
  }
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
